<script setup lang="ts">
const { color = "#333333" } = defineProps<{
  color?: string;
}>();
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 64 64"
  >
    <polygon
      points="32,1 42.4,24 63,24 46.4,40 52.8,63 32,49 11.2,63 17.6,40 1,24 21.6,24"
      :fill="color"
    />
  </svg>
</template>
